import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { VbzModal, VbzButton } from "@smiles/voebiz-ui-kit";
import { ModalBody, ModalFooter } from "reactstrap";

import { useTransactions } from "../../context/TransactionsContext";

const ThreeYearsModal: FC = () => {
  const { t } = useTranslation("threeYearsModal");
  const { state, dispatch } = useTransactions();

  const closeModal = () =>
    dispatch({
      type: "MODAL",
      modals: { filterModalOpen: false, threeYearsModalOpen: false, legacyUserModalOpen: false },
    });

  return (
    <VbzModal isOpen={state.modals.threeYearsModalOpen} className="three-years-modal" toggle={closeModal}>
      <ModalBody>
        <h4 className="three-years-modal__title-sended">{t("title")}</h4>

        <p className="three-years-modal__body">{t("body")}</p>
      </ModalBody>

      <ModalFooter className="three-years-modal__footer-sended">
        <VbzButton className="three-years-modal__btn" text={t("understood")} onClick={closeModal} />
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a href="#" className="three-years-modal__link">
          {t("goToHome")}
        </a>
      </ModalFooter>
    </VbzModal>
  );
};

export default ThreeYearsModal;
